import {Helmet} from "react-helmet";
import { Box, Container, Divider, IconButton, Stack, Typography} from "@mui/material";
import {Instagram, LinkedIn, Twitter} from "@mui/icons-material";
import { useState } from "react";
import { styled } from '@mui/material/styles';
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp';
import MuiAccordion from '@mui/material/Accordion';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import MuiAccordionDetails from '@mui/material/AccordionDetails';

const Accordion = styled((props) => (
    <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
    border: `1px solid ${theme.palette.divider}`,
    '&:not(:last-child)': {
        borderBottom: 0,
    },
    '&:before': {
        display: 'none',
    },
}));

const AccordionSummary = styled((props) => (
    <MuiAccordionSummary
        expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: '0.9rem' }} />}
        {...props}
    />
))(({ theme }) => ({
    backgroundColor:
        theme.palette.mode === 'dark'
            ? 'rgba(255, 255, 255, .05)'
            : 'rgba(0, 0, 0, .03)',
    flexDirection: 'row-reverse',
    '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
        transform: 'rotate(90deg)',
    },
    '& .MuiAccordionSummary-content': {
        marginLeft: theme.spacing(1),
    },
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
    padding: theme.spacing(2),
    borderTop: '1px solid rgba(0, 0, 0, .125)',
}));




export default function AboutUs() {
    const [expanded, setExpanded] = useState('panel1');

    const handleChange = (panel) => (event, newExpanded) => {
        setExpanded(newExpanded ? panel : false);
    };

    return (
        <>
            <Helmet>
                <title>درباره ما - میلفا</title>
                </Helmet>
            <Container sx={{ mt: 3, mb: 7 }}>
                <Box sx={{ maxWidth: {lg: "75%"} }}>
                    <Typography fontSize={{ xs: "1.15rem", lg: "1.25rem" }} fontWeight={700}>میلفا، فضای اشتراک ابری</Typography>
                    <Typography mt={1} textAlign="justify">امروزه استفاده از فضاهای ابری ذخیره فایل به یک امر مهم و روزمره تبدیل شده است اما میزان دسترسی پذیری و سادگی کار با این نوع نرم افزارها باعث شده است افراد زیادی از مزایا و امکانات این نوع سرویسها بی بهره باشند.</Typography>
                    <Typography mt={1} textAlign="justify">فضاهای ابری ذخیره فایل علاوه بر ایجاد دسترسی آسان به فایلهای شما با نگهداری تصاویر و عکسهای قدیمی در فضای ابری باعث صرفه جویی در فضای گوشی های همراه شما خواهد بود.</Typography>
                    <Typography mt={1} textAlign="justify">فضای ابری ذخیره سازی و اشتراک فایل میلفا یک محیط ایمن و آسان برای نگهداری و پشتیبان گیری و دسترسی آسان به فایلهای شما از هر محیطی هست.</Typography>
                    <Typography mt={1} textAlign="justify">با عضویت در فضای ابری اشتراک فایل میلفا میتوانید فایلهای مهم و ضروری خود را که ممکن است در هر زمان و مکانی به آنها نیاز پیدا کنید ذخیره کرده و با استفاده از گوشی، رایانه شخصی در هر زمان و مکانی به آنها دسترسی داشته باشید.</Typography>
                    <Typography mt={1} textAlign="justify">شما با کمک فضای ابری میلفا میتوانید فایلهای خود را برای هر کسی که فقط یک شماره تماس از وی دارید به اشتراک بگذراید، برای دریافت فایلهای اشتراک گذاری شده نیازی به نصب هیچ نرم افزار یا اپلیکیشنی نیست و فایلهای اشتراک گذاری شده به آسانی از طریق وب سایت، اپلیکیشن اندروید و ای او اس میلفا در اختیار گیرنده قرار خواهد گرفت.</Typography>
                    <Typography mt={1} textAlign="justify">در صورت نصب اپلیکیشن موبایل میلفا شما میتوانید از گوشی خود نسخه پشتیبان تهیه کنید و همچنین گالری تصاویر و سایر اطلاعات مهم گوشی را بر روی فضای ابری میلفا ذخیره کنید تا در صورت نیاز و یا بروز مشکل به راحتی به آنها دسترسی داشته باشید.</Typography>
                    <Typography mt={1} textAlign="justify">فضای ابری اشتراک فایل میلفا با ایجاد امکاناتی نظیر رمزگذاری دسترسی به اشتراک گذاری ها و یا ایجاد تاریخ انقضاء شما را در محدود کردن دسترسی به فایلهای اشتراکی کمک میکند.</Typography>
                    <Typography mt={1} textAlign="justify">برای آشنایی بیشتر با امکانات فضای ابری میلفا میتوانید بخشهای راهنما را مشاهده کنید.</Typography>
                    <Divider sx={{ my: 2 }}/>
                    <Typography fontSize={{ xs: "1.15rem", lg: "1.25rem" }} mt={2.5} fontWeight={700}>پرسش و پاسخ :</Typography>
                    <div>
                        <Accordion expanded={expanded === 'panel1'} onChange={handleChange('panel1')}>
                            <AccordionSummary aria-controls="panel1d-content" id="panel1d-header">
                                <Typography>فضای ابری میلفا چیست؟</Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <Typography>فضای ابری میلفا یک فضای ذخیره سازی اینترنتی است که فایلهای شما را در یک محیط امن نگهداری و ساماندهی میکند.</Typography>
                            </AccordionDetails>
                        </Accordion>
                        <Accordion expanded={expanded === 'panel2'} onChange={handleChange('panel2')}>
                            <AccordionSummary aria-controls="panel2d-content" id="panel2d-header">
                                <Typography>امکانات خاص درایو میلفا چیست؟</Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <Typography>درایو میلفا از یک محیط بسیار آسان و کاربردی بهره میبرد که میتوانید به راحتی پوشه ایجاد کرده و فایلهای خود را به درایو میلفا ارسال کنید علاوه بر این امکان بسیار جذاب دریافت و ارسال فایل نیز شما را از ارسال و دریافت فایلهای خود از طریق سایر نرم افزارها بی نیاز میکند.</Typography>
                            </AccordionDetails>
                        </Accordion>
                        <Accordion expanded={expanded === 'panel3'} onChange={handleChange('panel3')}>
                            <AccordionSummary aria-controls="panel3d-content" id="panel3d-header">
                                <Typography>در میلفا چه مقدار فضای ابری در اختیار من است؟</Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <Typography>به محض عضویت در میلفا شما صاحب 1 گیگ فضای ابری برای ذخیره سازی و ارسال و دریافت فایل خواهید بود.اما میتوانید با سفارش پلن های میلفا فضای خود و امکانات خود را افزایش دهید.</Typography>
                            </AccordionDetails>
                        </Accordion>
                    </div>
                    {/*<Divider sx={{ my: 2 }}/>*/}
                    {/*<Stack direction='row' alignItems='center' justifyContent={{ xs: "center", lg: "initial" }} spacing={2.5}>*/}
                    {/*    <a href="#" target="_blank">*/}
                    {/*        <IconButton>*/}
                    {/*            <LinkedIn sx={{ fontSize: "2rem" }}/>*/}
                    {/*        </IconButton>*/}
                    {/*    </a>*/}
                    {/*    <a href="#" target="_blank">*/}
                    {/*        <IconButton>*/}
                    {/*            <Instagram sx={{ fontSize: "2rem" }}/>*/}
                    {/*        </IconButton>*/}
                    {/*    </a>*/}
                    {/*    <a href="#" target="_blank">*/}
                    {/*        <IconButton>*/}
                    {/*            <Twitter sx={{ fontSize: "2rem" }}/>*/}
                    {/*        </IconButton>*/}
                    {/*    </a>*/}
                    {/*</Stack>*/}
                </Box>
            </Container>
        </>
    )
}
